import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { PACKAGE_PERIOD } from '~/endpoints';
import { PackagePeriodRequestSchema, PackagePeriodResponseSchema } from '~/validation/api/packagePeriodResponse';
import { handleErrorResponse } from '~/helpers/api';
import { PackagePeriodRequest } from '~/types/api';

export const getPackagePeriod = async (data: PackagePeriodRequest) => {
  const body = PackagePeriodRequestSchema.parse(data);

  const api = PACKAGE_PERIOD.replace(':packageId', body.package_id.toString());

  try {
    const response = await axios.post(api, body);

    const json = response.data;

    return PackagePeriodResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function usePackagePeriod(obj: PackagePeriodRequest) {
  return useQuery({
    queryKey: ['packagePeriod', obj.package_id, obj.locale],
    queryFn: () => getPackagePeriod(obj),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
